// extracted by mini-css-extract-plugin
export default {"scoreContainer":"YesNoScoreComponent_scoreContainer__RoJxH","header":"YesNoScoreComponent_header__H96dK","options":"YesNoScoreComponent_options__2YcoV"};